/* Movatic WMS — Frontend | CesarFilho 932048016 */
import CrudList from '@/components/CrudList'

export default function Companies() {
  return (
    <CrudList
      title="Empresas"
      endpoint="/api/core/companies/"
      columns={[
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Nome' },
      ]}
    />
  )
}
